// extracted by mini-css-extract-plugin
module.exports = {"varSpUp3":"1.75rem","varSpUp4":"2rem","radioButtonsContainer":"radioButtonsContainer--665e9","radioButton":"radioButton--92fa9","radioToggleSwitch":"radioToggleSwitch--37068"};